import reflectQueue from './reflectQueue';
export default function isReflecting(name) {
	const {length: reflectCount} = reflectQueue;
	for (let i = 0; i < reflectCount; i++) {
		if (name === reflectQueue[i]) return name;
	}
}
